import BigModal from "../common/modals/BigModal";
import FloatingLabelInput from "../common/inputs/FloatingLabelInput";
import FloatingLabelTextarea from "../common/inputs/FloatingLabelTextArea";
import config from "../../config";

const ContactModal = ({ t, contact, onClose }) => {
  const isSent = contact.isSent;
  const logo = <div className="big-modal-main"><img src={config.globalLogo} alt="Logo"></img></div>

  const handleClose = () => {
    onClose(isSent);
  }

  const sentBody = (isSent &&
    <div className="big-modal-main">
      <h2>{t("pages.about_us.submenus.contact.modal.title_sent", { returnObjects: true })}</h2>
      <div className="input-container">
        <FloatingLabelInput label={t("pages.about_us.submenus.contact.modal.email")} value={contact.email} disabled  />
        <FloatingLabelInput label={t("pages.about_us.submenus.contact.modal.name")} value={contact.name} disabled />
        <FloatingLabelInput label={t("pages.about_us.submenus.contact.modal.subject")} value={contact.subject} disabled />
        <FloatingLabelTextarea label={t("pages.about_us.submenus.contact.modal.body")} value={contact.body} disabled />
      </div>
    </div>
  );

  const sentButton = (
    <button onClick={handleClose} className="modal-button close-modal-button">{t("pages.about_us.submenus.contact.modal.close", { returnObjects: true })}</button>
  );

  const notSentBody = (!isSent &&
    <div className="big-modal-main">
      <h2>{t("pages.about_us.submenus.contact.modal.title_not_sent", { returnObjects: true })}</h2>
      <div className="input-container">
        {t("pages.about_us.submenus.contact.modal.text_not_sent")}
      </div>
      <img src="/images/result/vote-no_12503624.png" alt="Error" width="50px" height="50px" style={{ marginBottom: "10px"}}/>
    </div>
  );

  const notSentButton = (
    <button onClick={handleClose} className="modal-button continue-modal-button">{t("pages.about_us.submenus.contact.modal.try_again", { returnObjects: true })}</button>
    //<button onClick={handleClose} className="modal-button continue-modal-button">{t("pages.about_us.submenus.contact.modal.send", { returnObjects: true })}</button>
  );

  return (
    <BigModal
      leftContent={isSent ? sentBody : notSentBody}
      rightContent={logo}
      footerButton={isSent ? sentButton : notSentButton}
      onBack= {handleClose}
      onClose= {handleClose}
    />
  );
};

export default ContactModal;